export enum CardFieldType {
  Branch = 0,
  Intakes = 1,
  RequiredDocuments = 2,
  Exams = 3,
  OtherFees = 4,
  Scholarship = 5,
  HousingType = 6,
  ProgramDuration,
  SubmissionDate,
  StartDate,
  Deadline,
  Branches,
  Country,
  CourseDuration,
}
